<template>
	<!--collapse 是否水平折叠收起菜单-->
	<el-menu :default-active="$route.path" class="el-menu-vertical-demo" background-color="#545c64" text-color="#fff"
		active-text-color="#ffd04b"
		>
		<img src="../assets/images/user.png" class="img-user" />
		<h3 class="name">{{userName}}</h3>
		<el-menu-item :index="item.path" v-for="item in noChildren" :key="item.path" @click="clickMenu(item)">
			<i :class="'iconfont icon-' + item.icon"></i>
			<span slot="title">{{ item.label }}</span>
		</el-menu-item>
		<el-submenu :index="item.label" v-for="(item, index) in hasChildren" :key="index">
			<template slot="title">
				<i :class="'iconfont icon-' + item.icon"></i>
				<span slot="title">{{ item.label }}</span>
			</template>
			<el-menu-item-group>
				<el-menu-item :index="subItem.path" v-for="(subItem, subIndex) in item.children" :key="subIndex"
					@click="clickMenu(subItem)">
					<span slot="title">{{ subItem.label }}</span>
				</el-menu-item>
			</el-menu-item-group>
		</el-submenu>
	</el-menu>
</template>

<script>
	export default {
		//计算属性
		computed: {
			//没有子菜单
			noChildren() {
				return this.menu.filter(item => !item.children)
			},
			//有子菜单 (这样设置会有一个问题 就是有子菜单的 永远会在没有子菜单的下面
			hasChildren() {
				return this.menu.filter(item => item.children)
			},
			userName() {
				return this.$store.state.tab.userName;
			}
		},
		data() {
			return {
				menu: [
					{
						label: '商品管理',
						icon: 'data',
						children: [
							{
								path: '/goods',
								name: 'goods',
								label: '商品管理',
								url: 'goods/all'
							},
							{
								path: '/supplier',
								name: 'supplier',
								label: '供应商管理',
								url: 'goods/supplier'
							}
						]
					},
					{
						label: '用户管理',
						icon: 'account',
						children: [{
								path: '/users',
								name: 'users',
								label: '用户管理',
								url: 'users/all'
							}
						]
					},
					{
						label: '订单管理',
						icon: 'staff',
						children: [
							{
								path: '/telOrder',
								name: 'telOrder',
								label: '话费订单',
								url: 'order/tel'
							},
							{
								path: '/electricityOrder',
								name: 'electricityOrder',
								label: '电费订单',
								url: 'order/electricity'
							},
							//油卡
							{
								path: '/oilOrder',
								name: 'oilOrder',
								label: '油卡订单',
								url: 'order/oil'
							},

							//油码
							{
								path: '/oilCodeOrder',
								name: 'oilCodeOrder',
								label: '油码订单',
								url: 'order/oil_code'
							},
							//水费
							{
								path: '/waterOrder',
								name: 'waterOrder',
								label: '水费订单',
								url: 'order/water'
							},
							//燃气
							{
								path: '/gasOrder',
								name: 'gasOrder',
								label: '气费订单',
								url: 'order/gas'
							},
              //音视频
              {
                path: '/videoOrder',
                name: 'videoOrder',
                label: '音视频订单',
                url: 'order/video'
              }
						]
					},
					{
						label: '分享管理',
						icon: 'data',
						children: [
							{
								path: '/shares',
								name: 'shares',
								label: '分享人管理',
								url: 'shares/supplier'
							},
							{
								path: '/cashout',
								name: 'cashout',
								label: '提现管理',
								url: 'shares/cashout'
							},
              {
                path: '/addtshare',
                name: 'addtshare',
                label: '电梯广告推广',
                url: 'shares/addtshare'
              }
						]
					},
				]

			}
		},
		methods: {
			//跳转路由 根据名称跳转
			clickMenu(item) {
				if (item.name != this.$route.name) {
					this.$store.commit('setMenuName', item.label);
					this.$nextTick(() => {
						this.$router.push({
							name: item.name,
						});
					});
				}

			}
		}
	}
</script>

<style lang="scss" scoped>
	.el-menu {
		height: 100%;
		border: none;

		h3 {
			color: #ffffff;
			text-align: center;
			line-height: 48px;
		}
	}

	.el-menu-vertical-demo:not(.el-menu--collapse) {
		width: 246px;
		min-height: 400px;
	}

	.iconfont {
		width: 18px;
		height: 18px;
		margin-right: 8px;
		background-size: 100% 100%;
	}

	.icon-account {
		background-image: url(../assets/images/icon/menu_account.png);
	}

	.icon-staff {
		background-image: url(../assets/images/icon/menu_staff.png);
	}

	.icon-data {
		background-image: url(../assets/images/icon/menu_data.png);
	}

	.icon-pay {
		background-image: url(../assets/images/icon/pay.png);
		width: 14px;
		height: 21px;
	}

	.img-user {
		width: 100px;
		height: 100px;
		border-radius: 50%;
		margin: 59px auto 13px;
		display: block;
	}

	.name {
		margin-bottom: 24px;
		font-weight: 500;
		opacity: 0.8;
		font-size: 16px;
		line-height: 16px !important;
	}
</style>
